import { z } from "zod";

export const frameCostPerImageUpscale = 50;

export const tool = "ai-image-upscaler";

export const scaleFactor = [2, 4] as const;
export const enhancementStyle = ["Resemblance", "Balanced", "Creative"] as const;

export const schema = z.object({
  image: z.instanceof(File),
  scaleFactor: z.number().refine((val) => val === 2 || val === 4, {
    message: "Scale can only be 2x or 4x",
  }),
  enhancementStyle: z.enum(enhancementStyle),
});

export const styleToCreativity: Record<(typeof enhancementStyle)[number], number> = {
  Resemblance: 0.1,
  Balanced: 0.2,
  Creative: 0.35,
} as const;

export function calculateFrameCost(scale: (typeof scaleFactor)[number]) {
  if (scale === 4) {
    return frameCostPerImageUpscale * 4;
  }
  return frameCostPerImageUpscale;
}
